import { Component, Input, OnChanges , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { isLastMinute } from '@app/shared/utils/lastminute';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-booking-block',
    templateUrl: './application-booking-block.component.html',
    styleUrls: ['./application-booking-block.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationBookingBlockComponent implements OnChanges {
    @Input() status?: any;

    lastminute = false;
    preapproval = false;

    constructor() {}

    ngOnChanges() {
        if (this.status.application.program.lastminute) {
            this.lastminute = isLastMinute(this.status.application);
        }
        this.preapproval = this.status.application.program.preapprovalrequired;
    }
}
